import assign from 'object-assign';
import { EventEmitter } from 'events';
import validate from 'validate.js';
import i18next from 'i18next';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const expireMonthAvaliableValues = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
];
const startExpireYear = new Date().getFullYear();
const yearsCount = 10;
const creditCardErrorMessage = '^CREDIT_CARD_NBR_INVALID';
const cvvErrorMessage = '^CVV_INVALID';
const BILLING_ADDRESS_ERRORS = {
    NAME: '^BILLING_ADDR_NAME_REQUIRED',
    STREET: '^STREET_ADDR_1_REQUIRED',
    CITY: '^CITY_REQUIRED',
    STATE: '^STATE_REQUIRED',
    ZIPCODE: '^ZIP_CODE_REQUIRED',
    EMAIL: '^EMAIL_NOT_VALID',
};
const billingAddressConstraints = {
    name: {
        presence: {
            message: BILLING_ADDRESS_ERRORS.NAME,
        },
    },
    street: {
        presence: {
            message: BILLING_ADDRESS_ERRORS.STREET,
        },
    },
    city: {
        presence: {
            message: BILLING_ADDRESS_ERRORS.CITY,
        },
    },
    state: {
        presence: {
            message: BILLING_ADDRESS_ERRORS.STATE,
        },
    },
    zipcode: {
        presence: {
            message: BILLING_ADDRESS_ERRORS.ZIPCODE,
        },
    },
    email: {
        presence: {
            message: BILLING_ADDRESS_ERRORS.EMAIL,
        },
        email: {
            message: BILLING_ADDRESS_ERRORS.EMAIL,
        },
    },
};
const creditCardConstraints = {
    cardNumber: {
        presence: {
            message: creditCardErrorMessage,
        },
        numericality: {
            onlyInteger: true,
            message: creditCardErrorMessage,
        },
        length: {
            minimum: 14,
            maximum: 16,
            message: creditCardErrorMessage,
        },
    },
    cvv: {
        presence: {
            message: cvvErrorMessage,
        },
        numericality: {
            onlyInteger: true,
            message: cvvErrorMessage,
        },
        length: {
            minimum: 3,
            maximum: 4,
            message: cvvErrorMessage,
        },
    },
};
let creditCardValidation = {};
let billingAddressValidation = {};
let fetchedCreditCard = {};
const BillingStore = assign({}, EventEmitter.prototype, {
    addChangeListener(callback) {
        this.on(AdminConstants.collectionChangeEvents, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(AdminConstants.collectionChangeEvents, callback);
    },
    emitChange() {
        this.emit(AdminConstants.collectionChangeEvents);
    },
    getExpireMonthAvaliableValues() {
        return expireMonthAvaliableValues;
    },
    getStartExpireYear() {
        return startExpireYear;
    },
    getExpireYearValues() {
        const values = [];
        for (let i = startExpireYear; i < startExpireYear + yearsCount; i += 1) {
            values.push(i);
        }
        return values;
    },
    validateCreditCard(data) {
        creditCardValidation = validate(data, creditCardConstraints);
    },
    validateBillingAddress(shipper) {
        billingAddressValidation = validate(shipper.billing_address, billingAddressConstraints);
    },
    getCreditCardValidation() {
        return creditCardValidation;
    },
    getBillingAddressValidation() {
        return billingAddressValidation;
    },
    getCreditCard() {
        return fetchedCreditCard;
    },
    updateCreditCard(data) {
        const { cardNumber, expiryMonth, expiryYear, cvv, userId } = data;
        const convertedData = {
            number: cardNumber,
            expiry_month: parseInt(expiryMonth, 10),
            expiry_year: expiryYear,
            cvv,
            userId,
        };
        CustomersActionCreators.updateCreditCard(convertedData);
    },
});
BillingStore.dispatchToken = AdminAppDispatcher.register((payload) => {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.VALIDATE_AND_CREATE_CREDIT_CARD:
            BillingStore.validateCreditCard(action.data);
            BillingStore.emitChange();
            if (!creditCardValidation) {
                BillingStore.updateCreditCard(action.data);
            }
            break;
        case ActionTypes.VALIDATE_AND_UPDATE_BILLING_ADDRESS:
            BillingStore.validateBillingAddress(action.shipper);
            BillingStore.emitChange();
            if (!billingAddressValidation) {
                const shipper = Object.assign({}, action.shipper);
                delete shipper.billing_address.validations;
                CustomersActionCreators.updateShipper(shipper);
            }
            break;
        case ActionTypes.RECEIVE_CREDIT_CARDS:
            fetchedCreditCard = action.data[0];
            BillingStore.emitChange();
            break;
        default:
    }
});
export default BillingStore;
